import hsFetch from 'hellospa/hs-fetch';
import * as Sentry from '@sentry/browser';
import { SignerAppRequest, Page, Field, Rule } from 'generated/types/HelloRequest';
import { validateSignerAppRequest } from 'generated/validators/validateHelloRequest';
import { assertDataIsValid } from 'hellospa/common/utils/validation';

type LegacySignerData = {
    dpi: Number,
    pages: Page[];
    fields: Field[];
    rules: Rule[];
};


function mapUnifiedJsonToLegacy(data: SignerAppRequest): LegacySignerData {
  return {
    dpi: 80,
    ...data,
  };
}

export async function loadData(cachedParamsToken: string): Promise<LegacySignerData> {
  const url = `/signer/getData?cached_params_token=${cachedParamsToken}`;
  const response = await hsFetch(url);
  const { data } = await response.json();

  return {
    dpi: 80,
    ...data,
  };
}


export async function loadUnifiedData(cachedParamsToken: string): Promise<LegacySignerData> {
  try {
    const url = `/signer/getUnifiedData?cached_params_token=${cachedParamsToken}`;
    const response = await hsFetch(url);
    const { data } = await response.json();
    assertDataIsValid(validateSignerAppRequest, data);
    return mapUnifiedJsonToLegacy(data);
  } catch (e) {
    Sentry.captureEvent({
      message: 'Signer getUnifiedData fallback was triggered',
    });
    return loadData(cachedParamsToken);
  }

}
